module.exports = __webpack_public_path__ + "static/media/globe.e3923b6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/globe.svg
// module id = 890
// module chunks = 0